import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=661ff014&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=ts"
export * from "./Breadcrumbs.vue?vue&type=script&lang=ts"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=661ff014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ff014",
  null
  
)

export default component.exports